import { assign } from '..';
import { CreativeProps, DOMBuilder } from '../../../types';
import { BlurBuilder } from './blur-builder';
import { ClickAreaBuilder } from './click-area-builder';
import styles from './index.scss';

export class ImageContainerBuilder {
  public static create(
    props: CreativeProps,
    domBuilder: DOMBuilder
  ): HTMLDivElement {
    const {
      isVertical,
      blurEffect,
      containerClassName,
      containerStyle,
      blurCreativeUrl,
      creativeUrl,
      clickArea
    } = props;

    const blurUrl = blurCreativeUrl || creativeUrl;
    const container = domBuilder.createElement<HTMLDivElement>('div');
    container.id = 'creative';
    container.className = containerClassName ?? styles.creativeContainer;

    if (containerStyle) {
      assign(container.style, containerStyle);
    }

    if (blurEffect?.show === true && blurUrl) {
      const blurElement = BlurBuilder.create(
        { creativeUrl: blurUrl, blurEffect, isVertical: !!isVertical },
        domBuilder
      );
      container.appendChild(blurElement);
    }

    if (clickArea) {
      const clickAreaElement = ClickAreaBuilder.create(clickArea);
      container.appendChild(clickAreaElement);
    }

    return container;
  }

  public updateStyle(
    container: HTMLDivElement,
    style: Partial<CSSStyleDeclaration>
  ): void {
    assign(container.style, {
      ...style
    });
  }
}
